export const VENDOR_ROLE = 'vendor';

export const MANUFACTURER_ROLE = 'manufacturer';

export const ADMIN_ROLE = 'admin';

export const EDITOR_ROLE = 'editor';

export const GUEST_ROLE = 'guest';

export const VENDOR_EDITOR_ROLE = 'vendor-editor';

export const MANUFACTURER_EDITOR_ROLE = 'manufacturer-editor';

export const VENDOR_GUEST_ROLE = 'vendor-guest';

export const MANUFACTURER_GUEST_ROLE = 'manufacturer-guest';

export const ADMINISTRATION_ROLES = Object.freeze([ADMIN_ROLE, EDITOR_ROLE, GUEST_ROLE]);

export const VENDOR_ROLES = Object.freeze([VENDOR_ROLE, VENDOR_EDITOR_ROLE, VENDOR_GUEST_ROLE]);

export const MANUFACTURER_ROLES = Object.freeze([
  MANUFACTURER_ROLE, MANUFACTURER_EDITOR_ROLE, MANUFACTURER_GUEST_ROLE,
]);



// WEBPACK FOOTER //
// ./src/utils/roles.js